import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
const imagine = ['Imagina despertar mañana y saber exactamente por dónde empezar.', 'Imagina abrir un espacio de tu casa y sentir alivio.', 'Imagina mirar tu semana con más claridad.', 'Imagina tener tus pendientes escritos, tus rutinas más simples y un plan para continuar.', 'Imagina dejar de sentir que todo está en tu cabeza.'];
const noWait = ['No necesitas esperar al lunes.', 'No necesitas esperar a tener más energía.', 'No necesitas esperar a que todo sea perfecto.'];
export function Imagine() {
  return <section className="w-full bg-linen px-5 py-20 sm:px-8 sm:py-28" data-id="element-60" data-mp="3rdvmh8h3mpuc">
      <div className="mx-auto max-w-3xl" data-id="element-61" data-mp="3nbqsu9qnht7p">
        <h2 className="font-serif text-4xl leading-tight text-ink sm:text-5xl" data-id="element-62" data-mp="3nctk4irvxxo5">
          Empieza hoy
        </h2>

        <ul className="mt-10 space-y-5" data-id="element-63" data-mp="1pjd27vwb0ufr">
          {imagine.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.07
        }} className="border-l-2 border-clay/50 pl-5 font-serif text-2xl leading-snug text-cocoa sm:text-3xl" data-id="element-64" data-mp="1lkdslxzmo9hz" data-mpi={index}>
              {line}
            </motion.li>)}
        </ul>

        <div className="mt-12 space-y-2 text-lg text-cocoa" data-id="element-65" data-mp="srv2y48lghm2">
          {noWait.map(line => <p key={line} data-id="element-66" data-mp="xqenq1bgbncu">{line}</p>)}
          <p className="pt-2 font-semibold text-ink" data-id="element-67" data-mp="xq6c0cr2eo38">Puedes empezar hoy.</p>
        </div>

        <div className="mt-12 border-t border-sand pt-12" data-id="element-68" data-mp="jyi0obon43nb">
          <h3 className="font-serif text-3xl text-terracotta sm:text-4xl" data-id="element-69" data-mp="o0msd4vj2q7b">
            Obtén tu copia ahora
          </h3>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-cocoa" data-id="element-70" data-mp="1bpedjcapa8al">
            Descarga <em className="not-italic font-medium text-ink" data-id="element-71" data-mp="1ghpemih6g04q">“Organiza Tu Vida en 7 Días”</em> y
            empieza a crear una vida más tranquila, más clara y más tuya.
          </p>
          <div className="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-72" data-mp="1mbu7awkzh2f7">
            <BuyButton label="Quiero organizar mi vida" data-id="element-73" data-mp="1hchjo9mafrbk" />
            <BuyButton label="Descargar mi ebook ahora" variant="outline" data-id="element-74" data-mp="1haws8sv9sohx" />
          </div>
          <p className="mt-5 text-sm text-cocoa/80" data-id="element-75" data-mp="1cclhmfx5i9yn">
            Precio especial desde solo <strong className="text-terracotta" data-id="element-76" data-mp="17ek1o3v0uqre">$9 USD</strong> por tiempo limitado.
          </p>
        </div>
      </div>
    </section>;
}